export default "__VITE_ASSET__DNMrYHRx__"